// export const PUBLIC_URL = process.env.PUBLIC_URL;
// export const MAXWIDTH = "1328px";

export const LOGIN_SUCCESS_MSG = "Thank you, User registration successfully completed";
export const COMMON_ERROR_MSG = "Something went wrong. Please try again later.";

export const LOGIN_DISPLAY_MSG = "Register/Login to view Heatmap";
export const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];
export const SUBSCRIBE_MSG = "Please Subscribe to View all Indices";
export const SUBSCRIBE_Success_MSG = "Subscription Under Devlopment";
// export const SUBSCRIBE_Success_MSG = "Subscription Successful";

export const Broad_Compare_msg = "Displaying All Broad Stocks";
export const Strategy_Compare_msg = "Displaying All Strategy Stocks";
export const Thematic_Compare_msg = "Displaying All Thematic Stocks";
export const Sector_Compare_msg = "Displaying All Sector Stocks";
export const All_Compare_msg = "Displaying All Stocks";

export const graph5names = [
    {
        fullNames: "NIFTY 50	", shortNames: "NFT50	", graphNames: "GNFT50",
    },
    {
        fullNames: "NIFTY MIDCAP 50	", shortNames: "NFTMC50	", graphNames: "GNFTMC50",
    },
    {
        fullNames: "NIFTY SMALLCAP 50	", shortNames: "NFTSC50	", graphNames: "GNFTSC50",
    },
    {
        fullNames: "NIFTY LARGEMIDCAP 250	", shortNames: "NFTLMC250	", graphNames: "GNFTLMC250",
    },
    {
        fullNames: "NIFTY BANK	", shortNames: "NFTBANK	", graphNames: "GNFTBANK",
    },
];

export const broadStocksNames = [
    {
        fullName: "NIFTY 50",
        shortName: "NFT50",
    },
    {
        fullName: "NIFTY NEXT 50",
        shortName: "NFTN50",
    },
    {
        fullName: "NIFTY 100",
        shortName: "NFT100",
    },
    {
        fullName: "NIFTY 200",
        shortName: "NFT200",
    },
    {
        fullName: "NIFTY TOTAL MARKET",
        shortName: "NFTTTLMAR",
    },
    {
        fullName: "NIFTY 500",
        shortName: "NFT500",
    },
    {
        fullName: "NIFTY500 MULTICAP 50:25:25",
        shortName: "NFT500MC50_25_25",
    },
    {
        fullName: "NIFTY500 LARGEMIDSMALL EQUAL-CAP WEIGHTED",
        shortName: "NFT500LGMSEQLCAPWTD",
    },
    {
        fullName: "NIFTY MIDCAP 150",
        shortName: "NFTMC150",
    },
    {
        fullName: "NIFTY MIDCAP 50",
        shortName: "NFTMC50",
    },
    {
        fullName: "NIFTY MIDCAP SELECT",
        shortName: "NFTMCSEL",
    },
    {
        fullName: "NIFTY MIDCAP 100",
        shortName: "NFTMC100",
    },
    {
        fullName: "NIFTY SMALLCAP 250",
        shortName: "NFTSC250",
    },
    {
        fullName: "NIFTY SMALLCAP 50",
        shortName: "NFTSC50",
    },
    {
        fullName: "NIFTY FULL SMALL CAP 100",
        shortName: "NFTFSC100",
    },
    {
        fullName: "NIFTY MICROCAP 250",
        shortName: "NFTMC250",
    },
    {
        fullName: "NIFTY LARGEMIDCAP 250",
        shortName: "NFTLMC250",
    },
    {
        fullName: "NIFTY MIDSMALLCAP 400",
        shortName: "NFTMSC400",
    },
]

export const strategyStockName = [
    {
        fullName: "NIFTY 100 EQUAL WEIGHT",
        shortName: "NFT100EQLWGT",
    },
    {
        fullName: "NIFTY 100 LOW VOLATILITY 30",
        shortName: "NFT100LVLT30",
    },
    {
        fullName: "NIFTY 50 ARBITRAGE",
        shortName: "NFT50A",
    },
    {
        fullName: "NIFTY 50 FUTURES PR",
        shortName: "NFT50FPR",
    },
    {
        fullName: "NIFTY 50 FUTURES TR",
        shortName: "NFT50FTR",
    },
    {
        fullName: "NIFTY200 MOMENTUM 30",
        shortName: "NFT200MOM30",
    },
    {
        fullName: "NIFTY200 ALPHA 30",
        shortName: "NFT200AL30",
    },
    {
        fullName: "NIFTY100 ALPHA 30",
        shortName: "NFT100AL30",
    },
    {
        fullName: "NIFTY ALPHA 50",
        shortName: "NFTAL50",
    },
    {
        fullName: "NIFTY ALPHA LOW VOLATILITY 30",
        shortName: "NFTALVLT30",
    },
    {
        fullName: "NIFTY ALPHA QUALITY LOW VOLATILITY 30",
        shortName: "NFTAQLTLVLT30",
    },
    {
        fullName: "NIFTY ALPHA QUALITY VALUE LOW VOLATILITY 30",
        shortName: "NFTAQLTVLLVLT30",
    },
    {
        fullName: "NIFTY DIVIDEND OPPORTUNITIES 50",
        shortName: "NFTDO50",
    },
    {
        fullName: "NIFTY GROWTH SECTORS 15",
        shortName: "NFTGRTHSEC15",
    },
    {
        fullName: "NIFTY HIGH BETA 50",
        shortName: "NFTHBETA50",
    },
    {
        fullName: "NIFTY LOW VOLATILITY 50",
        shortName: "NFTLVLT50",
    },
    {
        fullName: "NIFTY TOP 10 EQUAL WEIGHT",
        shortName: "NFTT10EQLWGT",
    },
    {
        fullName: "NIFTY100 QUALITY 30",
        shortName: "NFT100QLT30",
    },
    {
        fullName: "NIFTY MIDCAP150 MOMENTUM 50",
        shortName: "NFTMC150MOM50",
    },
    {
        fullName: "NIFTY500 MOMENTUM 50",
        shortName: "NFT500MOM50",
    },
    {
        fullName: "NIFTY MIDCAP150 QUALITY 50",
        shortName: "NFTMC150QLT50",
    },
    {
        fullName: "NIFTY SMALLCAP250 QUALITY 50",
        shortName: "NFTSC250QLT50",
    },
    {
        fullName: "NIFTY MIDSMALLCAP400 MOMENTUM QUALITY 100",
        shortName: "NFTMSC400MOMQLT100",
    },
    {
        fullName: "NIFTY SMALLCAP250 MOMENTUM QUALITY 100",
        shortName: "NFTSC250MOMQLT100",
    },
    {
        fullName: "NIFTY QUALITY LOW VOLATILITY 30",
        shortName: "NFTQLTLVLT30",
    },
    {
        fullName: "NIFTY50 DIVIDEND POINTS",
        shortName: "NFT50DIVPNT",
    },
    {
        fullName: "NIFTY50 EQUAL WEIGHT",
        shortName: "NFT50EW",
    },
    {
        fullName: "NIFTY50 PR 1X INVERSE",
        shortName: "NFT50PR1XINVS",
    },
    {
        fullName: "NIFTY50 PR 2X LEVERAGE",
        shortName: "NFT50PR2XLVG",
    },
    {
        fullName: "NIFTY50 TR 1X INVERSE",
        shortName: "NFT50TR1XINVS",
    },
    {
        fullName: "NIFTY50 TR 2X LEVERAGE",
        shortName: "NFT50TR2XLVG",
    },
    {
        fullName: "NIFTY50 VALUE 20",
        shortName: "NFT50VL20",
    },
    {
        fullName: "NIFTY200 VALUE 30",
        shortName: "NFT200VL30",
    },
    {
        fullName: "NIFTY500 VALUE 50",
        shortName: "NFT500VL50",
    },
    {
        fullName: "NIFTY500 EQUAL WEIGHT",
        shortName: "NFT500EQLWGT",
    },
    {
        fullName: "NIFTY200 QUALITY 30",
        shortName: "NFT200QLT30",
    },
    {
        fullName: "NIFTY50 & SHORT DURATION DEBT – DYNAMIC P/B",
        shortName: "NFT50SRTDURDEBTDYNP_B",
    },
    {
        fullName: "NIFTY50 & SHORT DURATION DEBT – DYNAMIC P/E",
        shortName: "NFT50SRTDURDEBTDYNP_E",
    },
    {
        fullName: "NIFTY EQUITY SAVINGS",
        shortName: "NFTEQTSAV",
    },
]

export const thematicStockName = [
    {
        fullName: "NIFTY INDIA CORPORATE GROUP INDEX - ADITYA BIRLA GROUP",
        shortName: "NFTCORPGRPIABG",
    },
    {
        fullName: "NIFTY COMMODITIES",
        shortName: "NFTCOMM",
    },
    {
        fullName: "NIFTY CORE HOUSING",
        shortName: "NFTCH",
    },
    {
        fullName: "NIFTY CPSE",
        shortName: "NFTCPSE",
    },
    {
        fullName: "NIFTY ENERGY",
        shortName: "NFTENG",
    },
    {
        fullName: "NIFTY EV & NEW AGE AUTOMOTIVE",
        shortName: "NFTEVNAAMT",
    },
    {
        fullName: "NIFTY HOUSING",
        shortName: "NFTHOUS",
    },
    {
        fullName: "NIFTY100 ESG",
        shortName: "NFT100ESG",
    },
    {
        fullName: "NIFTY100 ENHANCED ESG",
        shortName: "NFT100EESG",
    },
    {
        fullName: "NIFTY100 ESG SECTOR LEADERS",
        shortName: "NFT100ESGSL",
    },
    {
        fullName: "NIFTY INDIA CONSUMPTION",
        shortName: "NFTCONS",
    },
    {
        fullName: "NIFTY INDIA DEFENCE",
        shortName: "NFTDEF",
    },
    {
        fullName: "NIFTY INDIA DIGITAL",
        shortName: "NFTINDDIG",
    },
    {
        fullName: "NIFTY INDIA MANUFACTURING",
        shortName: "NFTINDMFG",
    },
    {
        fullName: "NIFTY INDIA TOURISM",
        shortName: "NFTINDTR",
    },
    {
        fullName: "NIFTY INFRASTRUCTURE",
        shortName: "NFTINFS",
    },
    {
        fullName: "NIFTY INDIA CORPORATE GROUP INDEX - MAHINDRA GROUP",
        shortName: "NFTINDCORPGRPIMG",
    },
    {
        fullName: "NIFTY MIDCAP LIQUID 15",
        shortName: "NFTMCL15",
    },
    {
        fullName: "NIFTY MIDSMALL INDIA CONSUMPTION",
        shortName: "NFTMSINDCON",
    },
    {
        fullName: "NIFTY MNC",
        shortName: "NFTMNC",
    },
    {
        fullName: "NIFTY MOBILITY",
        shortName: "NFTMOB",
    },
    {
        fullName: "NIFTY PSE",
        shortName: "NFTPSE",
    },
    {
        fullName: "NIFTY REITS & INVITS",
        shortName: "NFTRI",
    },
    {
        fullName: "NIFTY NON-CYCLICAL CONSUMER INDEX",
        shortName: "NFTNCC",
    },
    {
        fullName: "NIFTY SERVICES SECTOR",
        shortName: "NFTSERSEC",
    },
    {
        fullName: "NIFTY SHARIAH 25",
        shortName: "NFTSH25",
    },
    {
        fullName: "NIFTY INDIA CORPORATE GROUP INDEX - TATA GROUP",
        shortName: "NFTINDCORPGRPITG",
    },
    {
        fullName: "NIFTY INDIA CORPORATE GROUP INDEX - TATA GROUP 25% CAP",
        shortName: "NFTINDCORPGRPITG25PC",
    },
    {
        fullName: "NIFTY TRANSPORTATION & LOGISTICS",
        shortName: "NFTTRANSLOG",
    },
    {
        fullName: "NIFTY100 LIQUID 15",
        shortName: "NFT100L15",
    },
    {
        fullName: "NIFTY50 SHARIAH",
        shortName: "NFT50SH",
    },
    {
        fullName: "NIFTY500 SHARIAH",
        shortName: "NFT500SH",
    },
    {
        fullName: "NIFTY500 MULTICAP INDIA MANUFATURING 50:30:20",
        shortName: "NFT500MULCINDMFG50_30_20",
    },
    {
        fullName: "NIFTY500 MULTICAP INFRASTRUCTURE 50:30:20",
        shortName: "NFT500MULCINFS50_30_20",
    },
    {
        fullName: "NIFTY SME EMERGE",
        shortName: "NFTSMEEMG",
    },
]

export const sectorStockName = [
    {
        fullName: "NIFTY AUTO",
        shortName: "NFTAUTO",
    },
    {
        fullName: "NIFTY BANK",
        shortName: "NFTBANK",
    },
    {
        fullName: "NIFTY FINANCIAL SERVICES",
        shortName: "NFTFINSERV",
    },
    {
        fullName: "NIFTY FINANCIAL SERVICES 25/50",
        shortName: "NFTFINSERV25_50",
    },
    {
        fullName: "NIFTY FINANCIAL SERVICES EX BANK",
        shortName: "NFTFINSERVEB",
    },
    {
        fullName: "NIFTY FMCG",
        shortName: "NFTFMCG",
    },
    {
        fullName: "NIFTY HEALTHCARE",
        shortName: "NFTHLTC",
    },
    {
        fullName: "NIFTY IT",
        shortName: "NFTIT",
    },
    {
        fullName: "NIFTY MEDIA",
        shortName: "NFTMEDIA",
    },
    {
        fullName: "NIFTY METAL",
        shortName: "NFTMETAL",
    },
    {
        fullName: "NIFTY PHARMA",
        shortName: "NFTPHARMA",
    },
    {
        fullName: "NIFTY PRIVATE BANK",
        shortName: "NFTPVTB",
    },
    {
        fullName: "NIFTY PSU BANK",
        shortName: "NFTPSUB",
    },
    {
        fullName: "NIFTY REALTY",
        shortName: "NFTREAL",
    },
    {
        fullName: "NIFTY CONSUMER DURABLES",
        shortName: "NFTCD",
    },
    {
        fullName: "NIFTY OIL AND GAS INDEX",
        shortName: "NFTOG",
    },
    {
        fullName: "NIFTY MIDSMALL FINANCIAL SERVICES",
        shortName: "NFTMSFS",
    },
    {
        fullName: "NIFTY MIDSMALL HEALTHCARE",
        shortName: "NFTMSHC",
    },
    {
        fullName: "NIFTY MIDSMALL IT & TELECOM",
        shortName: "NFTMSITTEL",
    },
    {
        fullName: "Nifty50 USD",
        shortName: "NFT50USD",
    },
    {
        fullName: "India VIX",
        shortName: "NFTVIX",
    },
]

export const graphStocks113Names = [
    {
        fullNames: "NIFTY 50	", shortNames: "NFT50	", graphNames: "GNFT50",
    },
    {
        fullNames: "NIFTY NEXT 50	", shortNames: "NFTN50	", graphNames: "GNFTN50",
    },
    {
        fullNames: "NIFTY 100	", shortNames: "NFT100	", graphNames: "GNFT100",
    },
    {
        fullNames: "NIFTY 200	", shortNames: "NFT200	", graphNames: "GNFT200",
    },
    {
        fullNames: "NIFTY TOTAL MARKET	", shortNames: "NFTTTLMAR	", graphNames: "GNFTTTLMAR",
    },
    {
        fullNames: "NIFTY 500	", shortNames: "NFT500	", graphNames: "GNFT500",
    },
    {
        fullNames: "NIFTY500 MULTICAP 50:25:25	", shortNames: "NFT500MC50_25_25	", graphNames: "GNFT500MC50_25_25",
    },
    {
        fullNames: "NIFTY500 LARGEMIDSMALL EQUAL-CAP WEIGHTED	", shortNames: "NFT500LGMSEQLCAPWTD	", graphNames: "GNFT500LGMSEQLCAPWTD",
    },
    {
        fullNames: "NIFTY MIDCAP 150	", shortNames: "NFTMC150	", graphNames: "GNFTMC150",
    },
    {
        fullNames: "NIFTY MIDCAP 50	", shortNames: "NFTMC50	", graphNames: "GNFTMC50",
    },
    {
        fullNames: "NIFTY MIDCAP SELECT	", shortNames: "NFTMCSEL	", graphNames: "GNFTMCSEL",
    },
    {
        fullNames: "NIFTY MIDCAP 100	", shortNames: "NFTMC100	", graphNames: "GNFTMC100",
    },
    {
        fullNames: "NIFTY SMALLCAP 250	", shortNames: "NFTSC250	", graphNames: "GNFTSC250",
    },
    {
        fullNames: "NIFTY SMALLCAP 50	", shortNames: "NFTSC50	", graphNames: "GNFTSC50",
    },
    {
        fullNames: "NIFTY FULL SMALL CAP 100	", shortNames: "NFTFSC100	", graphNames: "GNFTFSC100",
    },
    {
        fullNames: "NIFTY MICROCAP 250	", shortNames: "NFTMC250	", graphNames: "GNFTMC250",
    },
    {
        fullNames: "NIFTY LARGEMIDCAP 250	", shortNames: "NFTLMC250	", graphNames: "GNFTLMC250",
    },
    {
        fullNames: "NIFTY MIDSMALLCAP 400	", shortNames: "NFTMSC400	", graphNames: "GNFTMSC400",
    },
    {
        fullNames: "NIFTY 100 EQUAL WEIGHT	", shortNames: "NFT100EQLWGT	", graphNames: "GNFT100EQLWGT",
    },
    {
        fullNames: "NIFTY 100 LOW VOLATILITY 30	", shortNames: "NFT100LVLT30	", graphNames: "GNFT100LVLT30",
    },
    {
        fullNames: "NIFTY 50 ARBITRAGE	", shortNames: "NFT50A	", graphNames: "GNFT50A",
    },
    {
        fullNames: "NIFTY 50 FUTURES PR	", shortNames: "NFT50FPR	", graphNames: "GNFT50FPR",
    },
    {
        fullNames: "NIFTY 50 FUTURES TR	", shortNames: "NFT50FTR	", graphNames: "GNFT50FTR",
    },
    {
        fullNames: "NIFTY200 MOMENTUM 30	", shortNames: "NFT200MOM30	", graphNames: "GNFT200MOM30",
    },
    {
        fullNames: "NIFTY200 ALPHA 30	", shortNames: "NFT200AL30	", graphNames: "GNFT200AL30",
    },
    {
        fullNames: "NIFTY100 ALPHA 30	", shortNames: "NFT100AL30	", graphNames: "GNFT100AL30",
    },
    {
        fullNames: "NIFTY ALPHA 50	", shortNames: "NFTAL50	", graphNames: "GNFTAL50",
    },
    {
        fullNames: "NIFTY ALPHA LOW VOLATILITY 30	", shortNames: "NFTALVLT30	", graphNames: "GNFTALVLT30",
    },
    {
        fullNames: "NIFTY ALPHA QUALITY LOW VOLATILITY 30	", shortNames: "NFTAQLTLVLT30	", graphNames: "GNFTAQLTLVLT30",
    },
    {
        fullNames: "NIFTY ALPHA QUALITY VALUE LOW VOLATILITY 30	", shortNames: "NFTAQLTVLLVLT30	", graphNames: "GNFTAQLTVLLVLT30",
    },
    {
        fullNames: "NIFTY DIVIDEND OPPORTUNITIES 50	", shortNames: "NFTDO50	", graphNames: "GNFTDO50",
    },
    {
        fullNames: "NIFTY GROWTH SECTORS 15	", shortNames: "NFTGRTHSEC15	", graphNames: "GNFTGRTHSEC15",
    },
    {
        fullNames: "NIFTY HIGH BETA 50	", shortNames: "NFTHBETA50	", graphNames: "GNFTHBETA50",
    },
    {
        fullNames: "NIFTY LOW VOLATILITY 50	", shortNames: "NFTLVLT50	", graphNames: "GNFTLVLT50",
    },
    {
        fullNames: "NIFTY TOP 10 EQUAL WEIGHT	", shortNames: "NFTT10EQLWGT	", graphNames: "GNFTT10EQLWGT",
    },
    {
        fullNames: "NIFTY100 QUALITY 30	", shortNames: "NFT100QLT30	", graphNames: "GNFT100QLT30",
    },
    {
        fullNames: "NIFTY MIDCAP150 MOMENTUM 50	", shortNames: "NFTMC150MOM50	", graphNames: "GNFTMC150MOM50",
    },
    {
        fullNames: "NIFTY500 MOMENTUM 50	", shortNames: "NFT500MOM50	", graphNames: "GNFT500MOM50",
    },
    {
        fullNames: "NIFTY MIDCAP150 QUALITY 50	", shortNames: "NFTMC150QLT50	", graphNames: "GNFTMC150QLT50",
    },
    {
        fullNames: "NIFTY SMALLCAP250 QUALITY 50	", shortNames: "NFTSC250QLT50	", graphNames: "GNFTSC250QLT50",
    },
    {
        fullNames: "NIFTY MIDSMALLCAP400 MOMENTUM QUALITY 100	", shortNames: "NFTMSC400MOMQLT100	", graphNames: "GNFTMSC400MOMQLT100",
    },
    {
        fullNames: "NIFTY SMALLCAP250 MOMENTUM QUALITY 100	", shortNames: "NFTSC250MOMQLT100	", graphNames: "GNFTSC250MOMQLT100",
    },
    {
        fullNames: "NIFTY QUALITY LOW VOLATILITY 30	", shortNames: "NFTQLTLVLT30	", graphNames: "GNFTQLTLVLT30",
    },
    {
        fullNames: "NIFTY50 DIVIDEND POINTS	", shortNames: "NFT50DIVPNT	", graphNames: "GNFT50DIVPNT",
    },
    {
        fullNames: "NIFTY50 EQUAL WEIGHT	", shortNames: "NFT50EW	", graphNames: "GNFT50EW",
    },
    {
        fullNames: "NIFTY50 PR 1X INVERSE	", shortNames: "NFT50PR1XINVS	", graphNames: "GNFT50PR1XINVS",
    },
    {
        fullNames: "NIFTY50 PR 2X LEVERAGE	", shortNames: "NFT50PR2XLVG	", graphNames: "GNFT50PR2XLVG",
    },
    {
        fullNames: "NIFTY50 TR 1X INVERSE	", shortNames: "NFT50TR1XINVS	", graphNames: "GNFT50TR1XINVS",
    },
    {
        fullNames: "NIFTY50 TR 2X LEVERAGE	", shortNames: "NFT50TR2XLVG	", graphNames: "GNFT50TR2XLVG",
    },
    {
        fullNames: "NIFTY50 VALUE 20	", shortNames: "NFT50VL20	", graphNames: "GNFT50VL20",
    },
    {
        fullNames: "NIFTY200 VALUE 30	", shortNames: "NFT200VL30	", graphNames: "GNFT200VL30",
    },
    {
        fullNames: "NIFTY500 VALUE 50	", shortNames: "NFT500VL50	", graphNames: "GNFT500VL50",
    },
    {
        fullNames: "NIFTY500 EQUAL WEIGHT	", shortNames: "NFT500EQLWGT	", graphNames: "GNFT500EQLWGT",
    },
    {
        fullNames: "NIFTY200 QUALITY 30	", shortNames: "NFT200QLT30	", graphNames: "GNFT200QLT30",
    },
    {
        fullNames: "NIFTY50 & SHORT DURATION DEBT – DYNAMIC P/B	", shortNames: "NFT50SRTDURDEBTDYNP_B	", graphNames: "GNFT50SRTDURDEBTDYNP_B",
    },
    {
        fullNames: "NIFTY50 & SHORT DURATION DEBT – DYNAMIC P/E	", shortNames: "NFT50SRTDURDEBTDYNP_E	", graphNames: "GNFT50SRTDURDEBTDYNP_E",
    },
    {
        fullNames: "NIFTY EQUITY SAVINGS	", shortNames: "NFTEQTSAV	", graphNames: "GNFTEQTSAV",
    },
    {
        fullNames: "NIFTY INDIA CORPORATE GROUP INDEX - ADITYA BIRLA GROUP	", shortNames: "NFTCORPGRPIABG	", graphNames: "GNFTCORPGRPIABG",
    },
    {
        fullNames: "NIFTY COMMODITIES	", shortNames: "NFTCOMM	", graphNames: "GNFTCOMM",
    },
    {
        fullNames: "NIFTY CORE HOUSING	", shortNames: "NFTCH	", graphNames: "GNFTCH",
    },
    {
        fullNames: "NIFTY CPSE	", shortNames: "NFTCPSE	", graphNames: "GNFTCPSE",
    },
    {
        fullNames: "NIFTY ENERGY	", shortNames: "NFTENG	", graphNames: "GNFTENG",
    },
    {
        fullNames: "NIFTY EV & NEW AGE AUTOMOTIVE	", shortNames: "NFTEVNAAMT	", graphNames: "GNFTEVNAAMT",
    },
    {
        fullNames: "NIFTY HOUSING	", shortNames: "NFTHOUS	", graphNames: "GNFTHOUS",
    },
    {
        fullNames: "NIFTY100 ESG	", shortNames: "NFT100ESG	", graphNames: "GNFT100ESG",
    },
    {
        fullNames: "NIFTY100 ENHANCED ESG	", shortNames: "NFT100EESG	", graphNames: "GNFT100EESG",
    },
    {
        fullNames: "NIFTY100 ESG SECTOR LEADERS	", shortNames: "NFT100ESGSL	", graphNames: "GNFT100ESGSL",
    },
    {
        fullNames: "NIFTY INDIA CONSUMPTION	", shortNames: "NFTCONS	", graphNames: "GNFTCONS",
    },
    {
        fullNames: "NIFTY INDIA DEFENCE	", shortNames: "NFTDEF	", graphNames: "GNFTDEF",
    },
    {
        fullNames: "NIFTY INDIA DIGITAL	", shortNames: "NFTINDDIG	", graphNames: "GNFTINDDIG",
    },
    {
        fullNames: "NIFTY INDIA MANUFACTURING	", shortNames: "NFTINDMFG	", graphNames: "GNFTINDMFG",
    },
    {
        fullNames: "NIFTY INDIA TOURISM	", shortNames: "NFTINDTR	", graphNames: "GNFTINDTR",
    },
    {
        fullNames: "NIFTY INFRASTRUCTURE	", shortNames: "NFTINFS	", graphNames: "GNFTIGNFS",
    },
    {
        fullNames: "NIFTY INDIA CORPORATE GROUP INDEX - MAHINDRA GROUP	", shortNames: "NFTINDCORPGRPIMG	", graphNames: "GNFTINDCORPGRPIMG",
    },
    {
        fullNames: "NIFTY MIDCAP LIQUID 15	", shortNames: "NFTMCL15	", graphNames: "GNFTMCL15",
    },
    {
        fullNames: "NIFTY MIDSMALL INDIA CONSUMPTION	", shortNames: "NFTMSINDCON	", graphNames: "GNFTMSINDCON",
    },
    {
        fullNames: "NIFTY MNC	", shortNames: "NFTMNC	", graphNames: "GNFTMNC",
    },
    {
        fullNames: "NIFTY MOBILITY	", shortNames: "NFTMOB	", graphNames: "GNFTMOB",
    },
    {
        fullNames: "NIFTY PSE	", shortNames: "NFTPSE	", graphNames: "GNFTPSE",
    },
    {
        fullNames: "NIFTY REITS & INVITS	", shortNames: "NFTRI	", graphNames: "GNFTRI",
    },
    {
        fullNames: "NIFTY NON-CYCLICAL CONSUMER INDEX	", shortNames: "NFTNCC	", graphNames: "GNFTNCC",
    },
    {
        fullNames: "NIFTY SERVICES SECTOR	", shortNames: "NFTSERSEC	", graphNames: "GNFTSERSEC",
    },
    {
        fullNames: "NIFTY SHARIAH 25	", shortNames: "NFTSH25	", graphNames: "GNFTSH25",
    },
    {
        fullNames: "NIFTY INDIA CORPORATE GROUP INDEX - TATA GROUP	", shortNames: "NFTINDCORPGRPITG	", graphNames: "GNFTINDCORPGRPITG",
    },
    {
        fullNames: "NIFTY INDIA CORPORATE GROUP INDEX - TATA GROUP 25% CAP	", shortNames: "NFTINDCORPGRPITG25PC	", graphNames: "GNFTINDCORPGRPITG25PC",
    },
    {
        fullNames: "NIFTY TRANSPORTATION & LOGISTICS	", shortNames: "NFTTRANSLOG	", graphNames: "GNFTTRANSLOG",
    },
    {
        fullNames: "NIFTY100 LIQUID 15	", shortNames: "NFT100L15	", graphNames: "GNFT100L15",
    },
    {
        fullNames: "NIFTY50 SHARIAH	", shortNames: "NFT50SH	", graphNames: "GNFT50SH",
    },
    {
        fullNames: "NIFTY500 SHARIAH	", shortNames: "NFT500SH	", graphNames: "GNFT500SH",
    },
    {
        fullNames: "NIFTY500 MULTICAP INDIA MANUFATURING 50:30:20	", shortNames: "NFT500MULCINDMFG50_30_20	", graphNames: "GNFT500MULCINDMFG50_30_20",
    },
    {
        fullNames: "NIFTY500 MULTICAP INFRASTRUCTURE 50:30:20	", shortNames: "NFT500MULCINFS50_30_20	", graphNames: "GNFT500MULCIGNFS50_30_20",
    },
    {
        fullNames: "NIFTY SME EMERGE	", shortNames: "NFTSMEEMG	", graphNames: "GNFTSMEEMG",
    },
    {
        fullNames: "NIFTY AUTO	", shortNames: "NFTAUTO	", graphNames: "GNFTAUTO",
    },
    {
        fullNames: "NIFTY BANK	", shortNames: "NFTBANK	", graphNames: "GNFTBANK",
    },
    {
        fullNames: "NIFTY FINANCIAL SERVICES	", shortNames: "NFTFINSERV	", graphNames: "GNFTFINSERV",
    },
    {
        fullNames: "NIFTY FINANCIAL SERVICES 25/50	", shortNames: "NFTFINSERV25_50	", graphNames: "GNFTFINSERV25_50",
    },
    {
        fullNames: "NIFTY FINANCIAL SERVICES EX BANK	", shortNames: "NFTFINSERVEB	", graphNames: "GNFTFINSERVEB",
    },
    {
        fullNames: "NIFTY FMCG	", shortNames: "NFTFMCG	", graphNames: "GNFTFMCG",
    },
    {
        fullNames: "NIFTY HEALTHCARE	", shortNames: "NFTHLTC	", graphNames: "GNFTHLTC",
    },
    {
        fullNames: "NIFTY IT	", shortNames: "NFTIT	", graphNames: "GNFTIT",
    },
    {
        fullNames: "NIFTY MEDIA	", shortNames: "NFTMEDIA	", graphNames: "GNFTMEDIA",
    },
    {
        fullNames: "NIFTY METAL	", shortNames: "NFTMETAL	", graphNames: "GNFTMETAL",
    },
    {
        fullNames: "NIFTY PHARMA	", shortNames: "NFTPHARMA	", graphNames: "GNFTPHARMA",
    },
    {
        fullNames: "NIFTY PRIVATE BANK	", shortNames: "NFTPVTB	", graphNames: "GNFTPVTB",
    },
    {
        fullNames: "NIFTY PSU BANK	", shortNames: "NFTPSUB	", graphNames: "GNFTPSUB",
    },
    {
        fullNames: "NIFTY REALTY	", shortNames: "NFTREAL	", graphNames: "GNFTREAL",
    },
    {
        fullNames: "NIFTY CONSUMER DURABLES	", shortNames: "NFTCD	", graphNames: "GNFTCD",
    },
    {
        fullNames: "NIFTY OIL AND GAS INDEX	", shortNames: "NFTOG	", graphNames: "GNFTOG",
    },
    {
        fullNames: "NIFTY MIDSMALL FINANCIAL SERVICES	", shortNames: "NFTMSFS	", graphNames: "GNFTMSFS",
    },
    {
        fullNames: "NIFTY MIDSMALL HEALTHCARE	", shortNames: "NFTMSHC	", graphNames: "GNFTMSHC",
    },
    {
        fullNames: "NIFTY MIDSMALL IT & TELECOM	", shortNames: "NFTMSITTEL	", graphNames: "GNFTMSITTEL",
    },
    {
        fullNames: "Nifty50 USD	", shortNames: "NFT50USD	", graphNames: "GNFT50USD",
    },
    {
        fullNames: "India VIX	", shortNames: "NFTVIX	", graphNames: "GNFTVIX",
    },
]